import { TRequiredUploadConfig, TRequireDocumentStatus } from '~/modules/covenants/types.ts';

export const APPLICATION_FORM_LABELS = {
  back: 'Назад',
  applicationTitlePrefix: 'Заявка',
  applicationTitleNumberPrefix: 'Заявка №',
  createdAtPrefix: 'створено',
  signatureNoticeTitle:
    'Зверніть увагу! Нові документи потребують підпису КЕП керівника або уповноваженої особи.',
  signatureNoticeBeforeMenuIcon:
    'Якщо потрібно підписати документ КЕП або Дією, скористайтесь кнопки внизу сторінки.',
  signatureNoticeAllowedSignatureTypes:
    '(допустимі типи КЕП: токен (USB-пристрій), файловий ключ або хмарний підпис).',
  done: 'Готово',
  recreateRejected: 'Відтворити з відхилених',
  signAndSubmit: 'Підписати всі та надіслати заявку',
  submit: 'Надіслати заявку',
} as const;

export const APPLICATION_DOCUMENT_TABLE_HEADER_IDS = {
  name: 'name',
  comment: 'comment',
  period: 'period',
  deadline: 'deadline',
  status: 'status',
  actions: 'actions',
} as const;

export const APPLICATION_DOCUMENT_TABLE_HEADERS = [
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.name,
    label: 'Назва документа',
    align: 'left' as const,
    sx: { pl: 5.5, width: '35%', fontWeight: 700 },
  },
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.comment,
    label: 'Коментар',
    align: 'left' as const,
    sx: { width: '19%', fontWeight: 700 },
  },
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.period,
    label: 'Період / рік',
    align: 'left' as const,
    sx: { width: '14%', fontWeight: 700 },
  },
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.deadline,
    label: 'Термін',
    align: 'left' as const,
    sx: { width: '14%', fontWeight: 700 },
  },
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.status,
    label: 'Статус',
    align: 'left' as const,
    sx: { width: '14%', fontWeight: 700 },
  },
  {
    id: APPLICATION_DOCUMENT_TABLE_HEADER_IDS.actions,
    label: 'Дія',
    align: 'left' as const,
    sx: { width: '15%', fontWeight: 700 },
  },
] as const;

export const APPLICATION_DOCUMENT_TABLE_LABELS = {
  ariaLabel: 'documents table',
  empty: 'Немає документів для відображення',
} as const;

export const DOC_TABLE_ROW_LABELS = {
  emptyValue: '-',
  missingFile: 'Файл відсутній',
  expandDocument: 'Розгорнути документ',
  collapseDocument: 'Згорнути документ',
} as const;

export const DOC_ACTION_LABELS = {
  chooseAction: 'Обрати дію',
  uploadDocument: 'Завантажити документ',
  viewCovenant: 'Переглянути ковенант',
  generateDocument: 'Згенерувати документ',
  attachSignature: 'Підписати КЕП',
  previewDocument: 'Переглянути документ',
  downloadDocument: 'Скачати документ',
  deleteDocument: 'Видалити документ',
  fileActionsAria: 'Дії для файлу',
} as const;

export const DOC_ACTION_MENU_ID_PREFIXES = {
  document: 'document-actions-menu',
  file: 'file-actions-menu',
} as const;

export const DOC_ACTION_MENU_ORIGIN = {
  transform: { horizontal: 'right', vertical: 'top' },
  anchor: { horizontal: 'right', vertical: 'bottom' },
} as const;

export const TRANSPARENT_MENU_BACKDROP_STYLES = {
  backgroundColor: 'transparent',
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',
} as const;

export const DELETE_SIGNATURE_LABEL = 'Видалити підпис';

export const REQUIRED_UPLOAD_CONFIG: Record<TRequireDocumentStatus, TRequiredUploadConfig> = {
  PENDING: {
    requiresConfirmation: false,
    tone: 'solid',
  },
  IN_PROGRESS: {
    requiresConfirmation: true,
    tone: 'outlined',
  },
  ACCEPTED: {
    requiresConfirmation: true,
    tone: 'outlined',
  },
};

export const SIGNATURE_UPLOAD_LABEL = 'Вкласти файл підпису';

export const REQUIRED_DOCUMENT_UPLOAD_MODAL_CONTENT: Record<
  Exclude<TRequireDocumentStatus, 'PENDING'>,
  { title: string; message: string }
> = {
  IN_PROGRESS: {
    title: 'Документ обробляється',
    message:
      'Цей документ уже обробляється банком. Підтвердьте, що хочете завантажити нову версію.',
  },
  ACCEPTED: {
    title: 'Документ вже завантажено',
    message: 'Цей документ вже завантажено. Підтвердьте, що хочете завантажити нову версію.',
  },
};

export const MAX_DIIA_DOCUMENTS_FOR_SIGNING = 40;
export const DIIA_DOCUMENTS_LIMIT_MESSAGE =
  'Ви можете підписати за допомогою Дія.підпису до 40 документів.';

export const SIGNING_DOCUMENTS_PREFETCH_MIN_PAGE_SIZE = 20;
